import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './ToastNotification.css';

const ToastNotification = ({
  type = 'info',
  title,
  message,
  duration = 5000,
  position = 'top-right',
  actions = [],
  onClose,
  id
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setIsVisible(false);
      onClose?.(id);
    }, 300);
  };

  const handleActionClick = (action) => {
    action.onClick?.();
    if (action.closeOnClick !== false) {
      handleClose();
    }
  };

  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'error':
        return '';
      case 'warning':
        return '⚠️';
      case 'success':
        return '';
      case 'info':
      default:
        return 'ℹ️';
    }
  };

  const getTitle = () => {
    if (title) return title;
    switch (type) {
      case 'error':
        return 'Error';
      case 'warning':
        return 'Warning';
      case 'success':
        return 'Success';
      case 'info':
      default:
        return 'Information';
    }
  };

  return createPortal(
    <div 
      className={`toast-notification toast-${type} toast-${position} ${isExiting ? 'toast-exiting' : ''}`}
      role="alert"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="toast-content">
        <div className="toast-header">
          <div className="toast-icon" aria-hidden="true">
            {getIcon()}
          </div>
          <div className="toast-title">{getTitle()}</div>
          <button 
            className="toast-close" 
            onClick={handleClose} 
            aria-label="Close notification"
            type="button"
          >
            ×
          </button>
        </div>
        <div className="toast-message">{message}</div>
        {actions.length > 0 && (
          <div className="toast-actions">
            {actions.map((action, index) => (
              <button
                key={index}
                className={`toast-action ${action.primary ? 'toast-action-primary' : ''}`}
                onClick={() => handleActionClick(action)}
                type="button"
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default ToastNotification;
